// SharedDropdownStyles.js
import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const OptionsList = styled.ul`
  position: absolute;
  top: ${(props) => props.top ? `${viewSizeCalculator(props.top)}` : `${viewSizeCalculator(4.475)}`};

  ${(props) => (props.right ? "right: 0;" : "left: 0;")}
  max-height: ${(props) =>
    props.height ? `${viewSizeCalculator(props.height)}` : "none"};
  height: auto;
  width: ${(props) =>
    props.customWidth ? `${viewSizeCalculator(props.customWidth)}` : "100%"};
  background-color: #ffffff;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  overflow-y: scroll;
  box-shadow:
    0 ${() => `${viewSizeCalculator(0.0625)}`}
      ${() => `${viewSizeCalculator(0.3125)}`} #3333330a,
    /* lighter shadow */ 0 ${() => `${viewSizeCalculator(0.125)}`}
      ${() => `${viewSizeCalculator(0.625)}`} #33333314,
    /* lighter shadow */ 0 ${() => `${viewSizeCalculator(0.25)}`}
      ${() => `${viewSizeCalculator(1.25)}`} #3333331f;
  margin: 0;
  padding: ${(props) =>
    props.customPadding ? `${viewSizeCalculator(props.customPadding)}` : 0};
  padding-top: ${(props) =>
    props.paddingTop && `${viewSizeCalculator(props.paddingTop)}`};
  list-style: none;
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 400;
  z-index: 999;

  /* Add transition styles */
  transform: scaleY(${(props) => (props.isOpen ? 1 : 0)});
  transform-origin: top;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  transition:
    transform 0.3s ease,
    opacity 0.3s ease,
    visibility 0.3s ease ${(props) => (props.isOpen ? "0s" : "0.3s")};

  &:focus,
  &:focus-visible {
    outline: none;
  }

  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export const Option = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${viewSizeCalculator(0.7)} ${viewSizeCalculator(1)};
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  /* color: ${({ isSelected }) => (isSelected ? "#E35B42" : "#333")}; */
  color: ${({ isSortModel }) => (isSortModel ? "#007BFF" : "#333333")};
  background-color: ${({ isSelected }) =>
    isSelected ? "#F6F6F6" : "transparent"};
  background-color: ${({ isHighlighted }) =>
    isHighlighted ? "#f9f9f9" : "transparent"};
  cursor: pointer;

  ${({ isMargin }) => isMargin && `margin: ${viewSizeCalculator(0.4)} 0rem;`}

  &:hover {
    background-color: #f9f9f9;
  }

  border-radius: ${(props) =>
    props.customBorderRadius
      ? `${viewSizeCalculator(props.customBorderRadius)}`
      : "0px"};

  ${({ disabled }) =>
    disabled &&
    `
      cursor: not-allowed;
    `}
`;

export const Checkbox = styled.input`
  appearance: none;
  width: ${() => `${viewSizeCalculator(1)}`};
  height: ${() => `${viewSizeCalculator(1)}`};
  background-color: transparent;
  border: ${() => `${viewSizeCalculator(0.625)} solid rgb(144, 144, 144)`};
  border-radius: ${() => `${viewSizeCalculator(0.25)}`};
  cursor: pointer;
  display: inline-block;
  position: relative;

  &:checked {
    background-color: #e35b42;
    border: ${() => `${viewSizeCalculator(0.125)} solid #E35B42`};
  }

  &:checked::after {
    content: "✔";
    color: #fff;
    font-size: ${() => `${viewSizeCalculator(0.75)}`};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
  }
`;

export const Title = styled.div`
  height: ${() => `${viewSizeCalculator(2.063)}`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${() => `${viewSizeCalculator(1.5)} ${viewSizeCalculator(1)}`};
  cursor: default;
`;

export const Text = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 700;
`;

export const SubText = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 400;
  color: #333333;
  opacity: 60%;
  margin-top: ${() => `${viewSizeCalculator(0.25)}`};
  line-height: ${() => `${viewSizeCalculator(1.2)}`}; // 1rem
`;

export const SkeletonContainer  = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.666)}`};
`;

export const SkeletonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.666)}`};
  padding: ${viewSizeCalculator(0.7)} ${viewSizeCalculator(1)};
`;

export const NotFoundWrapper = styled.div`
  padding: ${viewSizeCalculator(1)} ${viewSizeCalculator(1)};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.666)}`};
`;

export const SearchWrapper = styled.div`
  position: sticky;
  top: 0;
  // top: ${() => `${viewSizeCalculator(0.75)}`};
  // margin: ${() => `${viewSizeCalculator(0.75)}`} auto;
  background: white;
  z-index: 10;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
`;

export const IconWrapper = styled.div`
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  transform: ${({ sortOrder }) =>
    sortOrder === "desc" ? "rotate(180deg)" : "none"};
`;

export const CustomIcons = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.5)}`};
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s ease,
    visibility 0s linear 0.3s;

  /* Show icons when hovering over StyledOption */
  ${Option}:hover & {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.3s ease;
  }
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  border-top: ${viewSizeCalculator(0.063)} solid rgba(51, 51, 51, 0.1);
  margin: ${viewSizeCalculator(0.5)} 0;
`;

export const SortModelIconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.25)}`};
  font-size: ${() => `${viewSizeCalculator(1)}`};
  font-weight: 500;

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
`;